import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IdamAuthService } from '@wsbc/ux-lib-security';

@Injectable()
export class IdamAuthenticationGuard implements CanActivate {
  constructor(private authService: IdamAuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.authService.isAuthenticated && this.authService.isAuthenticated.pipe(
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          console.log('IdamAuthenticationGuard- this.authService.redirectToSignInPage-state.url=' +state?.url);
          this.authService.redirectToSignInPage(state.url);
        }
      }),
      filter(isAuthenticated => isAuthenticated),
    );
  }
}
